import { z } from "zod/v4";
import { pollSchema } from "../schemas/poll";
import { fetchApi, fetchVoid } from "./internal";

export const polls = {
	list: (clubId: string) => fetchApi(`/clubs/${clubId}/polls`, z.array(pollSchema)),
	get: (clubId: string, pollId: string) => fetchApi(`/clubs/${clubId}/polls/${pollId}`, pollSchema),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/polls`, pollSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, pollId: string) =>
		fetchVoid(`/clubs/${clubId}/polls/${pollId}`, { method: "DELETE" }),
	vote: (clubId: string, pollId: string, optionIds: string[]) =>
		fetchVoid(`/clubs/${clubId}/polls/${pollId}/vote`, {
			method: "POST",
			body: JSON.stringify({ option_ids: optionIds }),
		}),
};
